import {
	helmetAccessoryItem,
	homeChargerAccessoryItem,
	chargerAdapterAccessoryItem,
	jacketAccessoryItem,
} from './accessoryItem';

import { onyxVehicle1, onyxVehicle2 } from './vehicleItem';

const oemId = 'rMJzmlnfAxQwhjTv5Qcj';
const checkoutItems = [
	onyxVehicle1,
	onyxVehicle2,
	helmetAccessoryItem,
	helmetAccessoryItem,
	homeChargerAccessoryItem,
	homeChargerAccessoryItem,
	chargerAdapterAccessoryItem,
	jacketAccessoryItem,
];
// eslint-disable-next-line no-restricted-syntax
for (const item of checkoutItems) {
	item.oemId = oemId;
}

const onyxDummyData = {
	checkoutItems,
	prevPage: '/',
	oemLogo: 'https://i.postimg.cc/WzLgXBwH/image-31-1.png',
};

export default onyxDummyData;
